export default (ctx, html) => html`
  <form id="register-form-container" name="register-form" @submit="${(e) => ctx.submitForm(e)}" novalidate>
    <fieldset>
      <div class="input-container ${ctx.form.email.valid ? '' : 'is-invalid'}">
        <label for="email">Email</label>
        <div class="input-wrapper">
          <input id="email" type="email" @blur="${(e) => ctx.validateEmail(e)}" @input="${(e) => ctx.updateEmail(e)}" value="${ctx.email}" autocomplete="email">
          ${ctx.form.email.isRequired.valid ? '' : html`
            <label class="error-message" for="email">Please enter an email address.</label>
          `}
          ${ctx.form.email.isValidEmail.valid && ctx.form.email.isNotEmoji.valid ? '' : html`
            <label class="error-message" for="email">Email format you entered is invalid.</label>
          `}
        </div>
      </div>
      <div class="input-container ${ctx.form.confirmEmail.valid ? '' : 'is-invalid'}">
        <label for="confirm-email">Confirm<span class="u-br"></span> Email</label>
        <div class="input-wrapper">
          <input id="confirm-email" type="email" @blur="${(e) => ctx.validateConfirmEmail(e)}" onpaste="return false" @input="${(e) => ctx.updateConfirmEmail(e)}" value="${ctx.confirmEmail}" autocomplete="email">
          ${ctx.form.confirmEmail.isRequired.valid ? '' : html`
            <label class="error-message" for="confirm-email">Please confirm your email.</label>
          `}
          ${ctx.form.confirmEmail.isEqual.valid ? '' : html`
            <label class="error-message" for="confirm-email">Email addresses do not match.</label>
          `}
        </div>
      </div>
      <div class="input-container ${ctx.form.password.valid ? '' : 'is-invalid'}">
        <label for="password">Password</label>
        <div class="input-wrapper">
          <input id="password" type="password" @blur="${(e) => ctx.validatePassword(e)}" @input="${(e) => ctx.updatePassword(e)}" value="${ctx.password}" autocomplete="new-password">
          ${ctx.form.password.isRequired.valid ? '' : html`
            <label class="error-message" for="password">Please enter a password.</label>
          `}
          ${ctx.form.password.minLength.valid ? '' : html`
            <label class="error-message" for="password">Password must be longer than 5 characters.</label>
          `}
          ${ctx.form.password.isNotEmail.valid ? '' : html`
            <label class="error-message" for="password">Password can't be an email address.</label>
          `}
          ${ctx.form.password.isNotAllDigits.valid ? '' : html`
            <label class="error-message" for="password">Password can't have only digits.</label>
          `}
        </div>
      </div>
      <div class="input-container ${ctx.form.confirmPassword.valid ? '' : 'is-invalid'}">
        <label for="confirm-password">Confirm<span class="u-br"></span> Password</label>
        <div class="input-wrapper">
          <input id="confirm-password" type="password" @blur="${(e) => ctx.validateConfirmPassword(e)}" @input="${(e) => ctx.updateConfirmPassword(e)}" onpaste="return false;" value="${ctx.confirmPassword}" autocomplete="new-password">
          ${ctx.form.confirmPassword.isRequired.valid ? '' : html`
            <label class="error-message" for="password">Please confirm your password.</label>
          `}
          ${ctx.form.confirmPassword.isEqual.valid ? '' : html`
            <label class="error-message" for="password">Passwords do not match.</label>
          `}
        </div>
      </div>
    </fieldset>
    <button id="register-submit-button" dom-scope="n0+jnS9p" type="submit" tabindex="-1"></button>
  </form>
`;
